import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsights = process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING
  ? new ApplicationInsights({
      config: {
        connectionString: process.env.REACT_APP_APP_INSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        autoTrackPageVisitTime: true,
        disableFetchTracking: true,
        loggingLevelConsole: 2,
      },
    })
  : null;

appInsights?.loadAppInsights();

export { reactPlugin, appInsights };
